module.exports = __webpack_public_path__ + "images/emoji/thumbsdown.2cf2c633709dfec4ca3c.png";